




























































































import { Component, Vue, Prop, InjectReactive } from 'vue-property-decorator';
import { PaycheckForm } from './PaycheckForm';

@Component
export default class PaycheckInfo extends Vue {
  @Prop({ type: Object, required: true }) private paycheck!: PaycheckForm;
  @InjectReactive() private isLocked!: boolean;
  @InjectReactive() private isPrint!: boolean;
  @InjectReactive() private hasEditPermissions!: boolean;

  private updateDueDate(date: string): void {
    this.paycheck.dueDate = this.$dayjs.strict(date).add(this.paycheck.workRelation.employee.creditDays, 'days').format('YYYY-MM-DD');
  }
}
